module.exports = __webpack_public_path__ + "img/woshi.686b2c49.png";